<template>
  <b-modal
    id="activate-client"
    title="Client Activation"
    ok-title="Save"
    ref="modal"
    @close="handleCancel"
    @cancel="handleCancel"
    @ok="handleOk"
    :cancel-disabled="disableConfirmButtons"
    :ok-disabled="disableConfirmButtons"
    :no-close-on-backdrop="true"
  >
    <br />
    <loading
      :active.sync="isLoading"
      loader="spinner"
      color="#20A8D8"
      :is-full-page="false"
    />
    <div>
      <span v-if="isActive">
        Are you sure you want to
        <b>deactivate</b>
        client
        <b>{{ selClient.title }}?</b>
      </span>
      <span v-else>
        Are you sure you want to
        <b>activate</b>
        client
        <b>{{ selClient.title }}?</b>
      </span>
    </div>
    <br />
  </b-modal>
</template>

<script>
// DAO
import clientDAO from '../../database/clients'

// Util
import dateUtil from '../../utils/dateUtil'

// Others
import { bus } from '../../main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'activate-client',
  components: {
    Loading,
  },
  data() {
    return {
      selClient: {},
      isActive: true,

      // Check for loader
      isLoading: false,
      loggedUser: this.$store.getters['auth/loggedUser'],
    }
  },
  computed: {
    disableConfirmButtons() {
      return this.isLoading
    },
  },
  mounted() {
    bus.$on('onUpdateSelClient', (selClient) => {
      this.selClient = Object.assign({}, selClient)
      this.isActive = selClient.isActive
    })
  },
  methods: {
    resetStatus() {
      this.selClient.isActive = this.isActive
      this.$store.commit('SET_CURR_CLIENT', this.selClient)
    },
    async handleCancel() {
      this.resetStatus()
      bus.$emit('onCloseActivateClient', this.selClient)
      this.isLoading = false
    },
    async handleOk() {
      try {
        // show loading indicator
        this.isLoading = true

        // update status
        this.selClient.isActive = !this.isActive
        // Update Timestamps
        this.selClient.updatedBy = this.loggedUser
        this.selClient.dateUpdated = dateUtil.getCurrentTimestamp()

        await clientDAO.updateClient(this.selClient, this.selClient.id)

        let activationLabel = this.selClient.isActive
          ? 'activated'
          : 'deactivated'
        this.$toast.success(
          `Client ${this.selClient.clientName} account is now ${activationLabel}!`,
          'Success',
        )
        this.$refs.modal.hide()
        bus.$emit('onCloseActivateClient', this.selClient)
      } catch (error) {
        console.error(error)
        let errorLabel = this.selClient.isActive ? 'activating' : 'deactivating'
        this.$toast.error(
          `There is an error ${errorLabel} client ${this.selClient.clientName}. Please try again.`,
          'Error',
        )
      }

      // hide loading indicator
      this.isLoading = false
    },
  },
  beforeDestroy() {
    bus.$off('onUpdateSelClient')
  },
}
</script>
